export type MicroTemplate = {
  id: string
  name: string
  background: string
  style: 'editorial' | 'gradients' | 'dark' | 'neon' | 'minimal' | 'solid' | 'photo'
}

export const DEFAULT_MICRO_TEMPLATE_ID = 'micro-editorial-01'

// CSS-only templates so we don't need image assets/CDN to get started.
// IDs are stable and safe to persist.
export const MICRO_TEMPLATES: MicroTemplate[] = [
  // Editorial pack: low-saturation, serious, subtle.
  { id: 'micro-editorial-01', name: 'Graphite', style: 'editorial', background: 'linear-gradient(135deg, #0b0c10 0%, #111827 55%, #0b1220 100%)' },
  { id: 'micro-editorial-02', name: 'Obsidian', style: 'editorial', background: 'linear-gradient(135deg, #07080b 0%, #0b1220 60%, #050609 100%)' },
  { id: 'micro-editorial-03', name: 'Ink', style: 'editorial', background: 'linear-gradient(135deg, #07101d 0%, #0b1220 55%, #030712 100%)' },
  { id: 'micro-editorial-04', name: 'Noir', style: 'editorial', background: 'linear-gradient(135deg, #07070a 0%, #0b0b12 55%, #06060a 100%)' },
  { id: 'micro-editorial-05', name: 'Slate', style: 'editorial', background: 'linear-gradient(135deg, #0a0f16 0%, #0f172a 60%, #0a0f16 100%)' },
  { id: 'micro-editorial-06', name: 'Midnight', style: 'editorial', background: 'linear-gradient(135deg, #050814 0%, #0b1026 55%, #02040b 100%)' },
  { id: 'micro-editorial-07', name: 'Drift', style: 'editorial', background: 'linear-gradient(135deg, #0c1017 0%, #111827 40%, #0b0f16 100%)' },
  { id: 'micro-editorial-08', name: 'Ash', style: 'editorial', background: 'linear-gradient(135deg, #0a0a0a 0%, #1f2937 55%, #0a0a0a 100%)' },

  { id: 'micro-premium-01', name: 'Aurora', style: 'gradients', background: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 45%, #a855f7 100%)' },
  { id: 'micro-premium-02', name: 'Night Ride', style: 'neon', background: 'linear-gradient(135deg, #0b1026 0%, #6d28d9 55%, #ec4899 100%)' },
  { id: 'micro-premium-03', name: 'Citrus', style: 'gradients', background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 55%, #7c3aed 100%)' },
  { id: 'micro-premium-04', name: 'Ocean', style: 'gradients', background: 'linear-gradient(135deg, #0ea5e9 0%, #14b8a6 60%, #0f172a 100%)' },
  { id: 'micro-premium-05', name: 'Graphite', style: 'minimal', background: 'linear-gradient(135deg, #0a0a0a 0%, #334155 55%, #111827 100%)' },
  { id: 'micro-premium-06', name: 'Sunset', style: 'gradients', background: 'linear-gradient(135deg, #fb7185 0%, #f97316 45%, #fde047 100%)' },
  { id: 'micro-premium-07', name: 'Mint', style: 'gradients', background: 'linear-gradient(135deg, #22c55e 0%, #38bdf8 55%, #1d4ed8 100%)' },
  { id: 'micro-premium-08', name: 'Rose', style: 'neon', background: 'linear-gradient(135deg, #f43f5e 0%, #a855f7 55%, #0ea5e9 100%)' },

  // Solid colors (simple, punchy backgrounds). IDs are stable.
  { id: 'micro-solid-01', name: 'Ink', style: 'solid', background: '#06070a' },
  { id: 'micro-solid-02', name: 'Obsidian', style: 'solid', background: '#0b0f19' },
  { id: 'micro-solid-03', name: 'Slate', style: 'solid', background: '#0f172a' },
  { id: 'micro-solid-04', name: 'Forest', style: 'solid', background: '#052e16' },
  { id: 'micro-solid-05', name: 'Ocean Blue', style: 'solid', background: '#082f49' },
  { id: 'micro-solid-06', name: 'Cobalt', style: 'solid', background: '#1e3a8a' },
  { id: 'micro-solid-07', name: 'Indigo', style: 'solid', background: '#312e81' },
  { id: 'micro-solid-08', name: 'Aubergine', style: 'solid', background: '#2e1065' },
  { id: 'micro-solid-09', name: 'Crimson', style: 'solid', background: '#7f1d1d' },
  { id: 'micro-solid-10', name: 'Copper', style: 'solid', background: '#7c2d12' },
]

export function resolveMicroTemplateBackground(id: string | null | undefined): string {
  const key = String(id || '').trim()
  const t = MICRO_TEMPLATES.find((x) => x.id === key)
  const fallback = MICRO_TEMPLATES.find((x) => x.id === DEFAULT_MICRO_TEMPLATE_ID) || MICRO_TEMPLATES[0]
  return t?.background || fallback.background
}

export const MICRO_TEMPLATE_STYLES: Array<MicroTemplate['style']> = ['editorial', 'gradients', 'solid', 'dark', 'neon', 'minimal', 'photo']
